
import { StateCreator } from 'zustand';
import {
    WorkflowI,
    WorkflowActionI,
} from '../../../libs/interfaces';

export const createWorkflowSlice: StateCreator<WorkflowI & WorkflowActionI, [], []> = ((set, get) => ({
    step: 'Formulario',
    activeKey:["1"],

    setStep: (step) => set(() => ({ step })),
    setActiveKey: (activeKey) => set(() => ({ activeKey })),
    resetSteps: () => set(() => ({
        step: 'Formulario',
    }))
}));
